import { useCurrentUserContext } from '@/contexts/CurrentUserContext';
import { NAV_HEIGHT } from '../SlimHeader/utils';
import { useIsExperiencePage } from './useIsExperiencePage';

export const APP_HEADER_HEIGHT = 60;
export const EXPERIENCE_HEADER_HEIGHT = 42;

const LEGACY_NAV_HEIGHT = parseInt(NAV_HEIGHT);

type AppHeaderState = {
  isActive: boolean;
};

// Signed-out visitors stay on the taller marketing header; everyone signed in
// gets the app header. An unresolved session reads as signed out, which is the
// safe default: the marketing header is what a visitor sees either way.
export const useAppHeaderState = (): AppHeaderState => {
  const { isAuthenticated } = useCurrentUserContext();

  return { isActive: isAuthenticated };
};

export const useHeaderHeight = (): number => {
  const { isActive } = useAppHeaderState();
  const isExperiencePage = useIsExperiencePage();

  if (!isActive) {
    return LEGACY_NAV_HEIGHT;
  }

  return isExperiencePage ? EXPERIENCE_HEADER_HEIGHT : APP_HEADER_HEIGHT;
};
